import React from 'react';
import { Text, Select, Input, Flex } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { SelectFunnelList } from "../../components/GeneralComponent/GeneralComponent";

export function PageOptions({
    ViewSelect,
    ViewSelectChange,
    ShowNumberChange,
    ActivePageNo,
    SelectedTestPageValue,
    selectedAllCreateTestPageValue,
    KeywordChange,
    selectedFunnelValue,
    setSelectedFunnelValue,
    selectedMemberWebsite
  }:any) {

  const AllCreateTestPagesoptions = [
    { value: '0', label: 'All Pages' },
    { value: '2', label: 'Pages with "Draft Tests"' },
    { value: '3', label: 'Pages in Funnel' }
  ];

  const handleSelectView = (selectedViewOption) => {
    ViewSelectChange(selectedViewOption);
  };

  const handleSelectAllCreateTestPagesValueChange = (selectedAllCreateTestPageOption) => {
    SelectedTestPageValue(selectedAllCreateTestPageOption);
    ActivePageNo(1);
  };

  const handleShowNumberChange = (selectedShowNumberOption) => {
    ShowNumberChange(selectedShowNumberOption);
    ActivePageNo(1);
  };

  const handleKeywordChange = (e) => {
    KeywordChange(e.target.value);
    ActivePageNo(1);
  };

  const handleChangeFunnel = (Value:any) => {
    setSelectedFunnelValue(Value);
  };

  return (
    <>
      <div style={{ display: 'flex'}}>
        <Text mt={5} mr={5}>Configured pages:</Text>
        <Select 
          w={200}
          defaultValue="0"
          data={AllCreateTestPagesoptions}
          onChange={(selectedAllCreateTestPageOption) => handleSelectAllCreateTestPagesValueChange(selectedAllCreateTestPageOption)}
          searchable
          nothingFound="No options"
          maxDropdownHeight={300}
          dropdownPosition="bottom"
          styles={{ input: { cursor: 'pointer' } }}
        />
        {selectedAllCreateTestPageValue === "3" && (
          <>
            <Text mt={5} ml={20} mr={5}>Select Funnel: </Text>
            <SelectFunnelList updated_time="" Value={selectedFunnelValue} OnChange={handleChangeFunnel} MemberWebsiteId={selectedMemberWebsite} Width={180}/>
          </>
        )}
        <Text mt={5} ml={20} mr={5}>View:</Text>
        <Select
          onChange={handleSelectView}
          defaultValue="grid"
          value={ViewSelect}
          data={[
            { value: 'grid', label: 'Grid' },
            { value: 'list', label: 'List' }
          ]}
          w={80}
        />
        <Text mt={5} ml={20} mr={5}>Show: </Text>
        <Select
          onChange={handleShowNumberChange}
          defaultValue="25"
          data={[
            { value: '10', label: '10' },
            { value: '25', label: '25' },
            { value: '50', label: '50' },
            { value: '100', label: '100' }
          ]}
          w={80}
        />
        <Flex
          style={{marginLeft:"auto"}}
          justify="flex-end"
          align="center"
          direction="row"
          wrap="wrap"
        >
          <Input icon={<IconSearch size={16} />} placeholder="Search"
            maxLength={50}
            autoFocus
            onChange={handleKeywordChange}
           />
        </Flex>
      </div>
    </>
  );
}